import React from "react";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RatingCard, RatingsStarsBlock } from "./RatingsStars";
import di from "../../di/serviceLocator";
export var profileSubtitles = [
    {
        title: "Strengths",
        data: [
            {
                text: "6-Star Service",
                value: "14",
                ratingStatus: true,
            },
        ],
    },
    {
        title: "Areas of improvement",
        data: [
            {
                text: "Great Execution",
                value: "6",
                ratingStatus: "",
            },
            {
                text: "Excellent Communication",
                value: "5",
                ratingStatus: "",
            },
            {
                text: "Extremely Professional",
                value: "13",
                ratingStatus: "",
            },
        ],
    },
    {
        title: "Weakness",
        data: [
            {
                text: "Expert Advice",
                value: "2",
                ratingStatus: false,
            },
            {
                text: "Extremely Professional",
                value: "13",
                ratingStatus: "",
            },
        ],
    },
];
var RatingsHead = [
    { head: "Old Ratings", value: 3.5, clientcount: 20 },
    { head: "Ratings", value: 4, clientcount: 0 },
    { head: "No Ratings", value: 0, clientcount: 1 },
];
var RatingsBlock = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var getRMRatingDetails = function () {
        di.profile.getRMDetailRating();
    };
    var getRMRating = function () {
        di.profile.getRatings();
    };
    var rmRatingDetails = useSelector(function (state) { return state.Profile.RMDetailsRatingReducer.data; });
    var rmRating = useSelector(function (state) { return state.Profile.RatingDetailReducer; });
    React.useEffect(function () {
        getRMRatingDetails();
        getRMRating();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "ratings-block mx-0" },
            React.createElement("div", { className: "DMSansBold_20_700 txt-midnight-blue ratings-head-tile d-flex" },
                "Ratings",
                React.createElement("div", { className: "ratings-icon " },
                    React.createElement("i", { className: "edel-icon-smooth-star txt_yellow  " }))),
            React.createElement("div", { className: "flexJustifySpaceBetween px-0 ratings-block-head-block" },
                React.createElement("div", null,
                    React.createElement("div", { className: "ratings-block-head" },
                        React.createElement("span", null,
                            "Old Ratings \u00A0\u00A0",
                            ((_b = (_a = rmRating.data) === null || _a === void 0 ? void 0 : _a.ratingsDetails) === null || _b === void 0 ? void 0 : _b.oldRatingDate) && (React.createElement("span", { className: "DMsanR_11_400 txt_primaryGrey" },
                                "(as on ", (_d = (_c = rmRating.data) === null || _c === void 0 ? void 0 : _c.ratingsDetails) === null || _d === void 0 ? void 0 :
                                _d.oldRatingDate,
                                ")")))),
                    React.createElement(RatingsStarsBlock, { clientcount: (_f = (_e = rmRating.data) === null || _e === void 0 ? void 0 : _e.ratingsDetails) === null || _f === void 0 ? void 0 : _f.oldRatingClientCnt, ratingnumber: (_h = (_g = rmRating.data) === null || _g === void 0 ? void 0 : _g.ratingsDetails) === null || _h === void 0 ? void 0 : _h.oldRating })),
                React.createElement("div", null,
                    React.createElement("div", { className: "ratings-block-head" },
                        "Ratings \u00A0\u00A0",
                        ((_k = (_j = rmRating.data) === null || _j === void 0 ? void 0 : _j.ratingsDetails) === null || _k === void 0 ? void 0 : _k.currentRatingDate) && (React.createElement("span", { className: "DMsanR_11_400 txt_primaryGrey" },
                            "(as on ", (_m = (_l = rmRating.data) === null || _l === void 0 ? void 0 : _l.ratingsDetails) === null || _m === void 0 ? void 0 :
                            _m.currentRatingDate,
                            ")"))),
                    React.createElement(RatingsStarsBlock, { clientcount: (_p = (_o = rmRating.data) === null || _o === void 0 ? void 0 : _o.ratingsDetails) === null || _p === void 0 ? void 0 : _p.currentRatingClientCnt, ratingnumber: Number((_r = (_q = rmRating.data) === null || _q === void 0 ? void 0 : _q.ratingsDetails) === null || _r === void 0 ? void 0 : _r.currentRating) })),
                React.createElement("div", null,
                    React.createElement("div", { className: "ratings-block-head" },
                        "No Ratings\u00A0\u00A0",
                        ((_t = (_s = rmRating.data) === null || _s === void 0 ? void 0 : _s.ratingsDetails) === null || _t === void 0 ? void 0 : _t.currentRatingDate) && (React.createElement("span", { className: "DMsanR_11_400 txt_primaryGrey" },
                            "(as on ", (_v = (_u = rmRating.data) === null || _u === void 0 ? void 0 : _u.ratingsDetails) === null || _v === void 0 ? void 0 :
                            _v.currentRatingDate,
                            ")"))),
                    React.createElement(RatingsStarsBlock, { clientcount: (_x = (_w = rmRating.data) === null || _w === void 0 ? void 0 : _w.ratingsDetails) === null || _x === void 0 ? void 0 : _x.noRatingClientCnt }))),
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement("div", { className: "flexjustifycenterstart px-0" },
                    React.createElement(RatingCard, { data: rmRatingDetails === null || rmRatingDetails === void 0 ? void 0 : rmRatingDetails.data }))))));
};
export default RatingsBlock;
